export const CHECK_STORAGE = 'CHECK_STORAGE';
let SESSION_STORAGE_AVAILABLE;

export function hasSessionStorage() {
  if (SESSION_STORAGE_AVAILABLE !== undefined) {
    return SESSION_STORAGE_AVAILABLE;
  }

  if (window.sessionStorage) {
    try {
      window.sessionStorage.setItem(CHECK_STORAGE, true);
      window.sessionStorage.removeItem(CHECK_STORAGE);
      SESSION_STORAGE_AVAILABLE = true;
      return SESSION_STORAGE_AVAILABLE;
    } catch (e) { /* ignore failures, pass on as storage unavailable */ }
  }
  SESSION_STORAGE_AVAILABLE = false;
  return SESSION_STORAGE_AVAILABLE;
}

export function setStoredValue(key, value) {
  if (hasSessionStorage()) {
    window.sessionStorage.setItem(key, value);
  }
  return value;
}

export function getStoredValue(key) {
  if (hasSessionStorage()) {
    return window.sessionStorage.getItem(key);
  }
  return null;
}

export function clearStoredValue(key) {
  if (hasSessionStorage()) {
    const value = window.sessionStorage.getItem(key);
    window.sessionStorage.removeItem(key);
    return value;
  }
  return null;
}



// WEBPACK FOOTER //
// ./utils/storage.js